/**
 * Sync Commerce7 customerToken to a domain-accessible cookie
 * 
 * Commerce7 sets customerToken as a cross-domain cookie that the server can't access.
 * This script watches for the token and re-sets it as a cookie on our domain.
 */
export default function commerce7CookieSync() {
  let checkInterval: ReturnType<typeof setInterval> | null = null

  function checkAndSetCookie() {
    // Debug: log all storage locations
    // console.log('=== Commerce7 Cookie Sync Debug ===')
    // console.log('window.c7:', (window as any).c7)
    // console.log('localStorage keys:', Object.keys(localStorage))
    // console.log('localStorage customerToken:', localStorage.getItem('customerToken'))
    // console.log('sessionStorage keys:', Object.keys(sessionStorage))
    // console.log('sessionStorage customerToken:', sessionStorage.getItem('customerToken'))
    // console.log('document.cookie:', document.cookie)
    // console.log('All cookies:', document.cookie.split(';').map(c => c.trim()))

    // Check multiple possible locations where Commerce7 might store the token
    
    // 1. Check window.c7 (if Commerce7 exposes it globally)
    if ((window as any).c7?.customer?.token) {
      const token = (window as any).c7.customer.token
      // console.log('Found token in window.c7.customer.token:', token)
      setCustomerTokenCookie(token)
      if (checkInterval) clearInterval(checkInterval)
      return
    }

    // 2. Check localStorage (some widgets store tokens there)
    const storedToken = localStorage.getItem('customerToken')
    if (storedToken) {
      // console.log('Found token in localStorage:', storedToken)
      setCustomerTokenCookie(storedToken)
      if (checkInterval) clearInterval(checkInterval)
      return
    }

    // 3. Check sessionStorage
    const sessionToken = sessionStorage.getItem('customerToken')
    if (sessionToken) {
      // console.log('Found token in sessionStorage:', sessionToken)
      setCustomerTokenCookie(sessionToken)
      if (checkInterval) clearInterval(checkInterval)
      return
    }

    // 4. Try to extract from the document.cookie
    if (document.cookie.includes('customerToken=')) {
      const match = document.cookie.match(/customerToken=([^;]+)/)
      if (match && match[1]) {
        // console.log('Found token in document.cookie:', match[1])
        setCustomerTokenCookie(match[1])
        if (checkInterval) clearInterval(checkInterval)
        return
      }
    }

    // 5. Check window for any token-like properties
    for (const key in window) {
      if (key.toLowerCase().includes('token') || key.toLowerCase().includes('customer')) {
        // console.log(`Found window property: ${key}`, (window as any)[key])
      }
    }
  }

  function setCustomerTokenCookie(token: string) {
    if (!token) return

    // Set a simple cookie without encoding to ensure server can parse it
    // Using minimal attributes to avoid SameSite/Secure issues
    document.cookie = `customerToken=${token}; path=/; max-age=604800`

    // console.log('✓ customerToken cookie set:', token.substring(0, 50) + '...')
  }

  // Start checking immediately and every 500ms for up to 10 seconds
  let attempts = 0
  const maxAttempts = 20 // 20 * 500ms = 10 seconds

  checkAndSetCookie()

  if (!document.cookie.includes('customerToken=')) {
    checkInterval = setInterval(() => {
      attempts++
      checkAndSetCookie()

      if (attempts >= maxAttempts && checkInterval) {
        clearInterval(checkInterval)
        // console.warn('Could not find Commerce7 customerToken after 10 seconds')
      }
    }, 500)
  }
}
